import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Card,
  InlineGrid,
  Text,
  Page,
  Icon,
  Divider,
  TextField,
  RadioButton,
  PageActions,
  Banner,
  Spinner,
  Checkbox,
  ProgressBar,
} from "@shopify/polaris";
import { CaretDownIcon, CaretUpIcon } from "@shopify/polaris-icons";
import { ReactComponent as SortAmount } from "./icons/sort-amount-down.svg";
import { ReactComponent as AddFriend } from "./icons/add-user-1.svg";
import { ReactComponent as Checkout } from "./icons/checkout.svg";
import { ReactComponent as Collaboration } from "./icons/refer-1.svg";
import { ReactComponent as Promotion } from "./icons/promo-1.svg";
import { ReactComponent as AppIcon } from "./icons/credup-icon.svg";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const Settings = ({ shopUrl }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const ref = useRef(null);
  const handleClick = () => {
    setTimeout(() => {
      ref.current?.scrollIntoView({ behavior: "smooth" });
      setTimeout(() => {
        setWarnings({ disabled: false, message: "", tone: "" });
      }, 3000);
    }, 500);
  };

  const [shopOwner, setShopOwner] = useState(null);
  const [openThreshold, setOpenThreshold] = useState(false);
  const [openFirstOrder, setOpenFirstOrder] = useState(false);
  const [openSignupOrder, setOpenSignupOrder] = useState(false);
  const [openReferral, setOpenReferral] = useState(false);
  const [openSeasonal, setOpenSeasonal] = useState(false);

  const [loader, setLoader] = useState(true);

  // Define states for each field and edit mode for each section
  const [orderThreshold, setOrderThreshold] = useState({
    greaterThan: "",
    greaterThanVal: "",
  });
  const [firstOrderCredit, setFirstOrderCredit] = useState("");
  const [signupStoreCredit, setSignupStoreCredit] = useState("");
  const [referralOnOrder, setReferralOnOrder] = useState("");
  const [referralOnSignup, setReferralOnSignup] = useState("");
  const [seasonalPromotion, setSeasonalPromotion] = useState({
    date: "",
    credit: "",
  });

  const [orderThresholdExpiry, setOrderThresholdExpiry] = useState("");
  const [firstOrderCreditExpiry, setFirstOrderCreditExpiry] = useState("");
  const [signupStoreCreditExpiry, setSignupStoreCreditExpiry] = useState("");
  const [referralExpiry, setReferralExpiry] = useState("");
  const [seasonalPromotionExpiry, setSeasonalPromotionExpiry] = useState("");

  const [orderThresholdExpiryEnable, setOrderThresholdExpiryEnable] =
    useState(false);
  const [firstOrderCreditExpiryEnable, setFirstOrderCreditExpiryEnable] =
    useState(false);
  const [signupStoreCreditExpiryEnable, setSignupStoreCreditExpiryEnable] =
    useState(false);
  const [referralExpiryEnable, setReferralExpiryEnable] = useState(false);
  const [seasonalPromotionExpiryEnable, setSeasonalPromotionExpiryEnable] =
    useState(false);

  const [isEditThreshold, setEditThreshold] = useState(true);
  const [isEditFirstOrder, setEditFirstOrder] = useState(true);
  const [isEditSignupOrder, setEditSignupOrder] = useState(true);
  const [isEditReferral, setEditReferral] = useState(true);
  const [isEditSeasonal, setEditSeasonal] = useState(true);

  const [thresholdCaret, setThresholdCaret] = useState(false);
  const [firstOrderCaret, setFirstOrderCaret] = useState(false);
  const [signupOrderCaret, setSignupOrderCaret] = useState(false);
  const [referralCaret, setReferralCaret] = useState(false);
  const [seasonalCaret, setSeasonalCaret] = useState(false);

  const [enableThresholdBtn, setEnableThresholdBtn] = useState(true);
  const [enableFirstOrderBtn, setEnableFirstOrderBtn] = useState(true);
  const [enablesignupStoredBtn, setEnablesignupStoredBtn] = useState(true);
  const [enablereferraldBtn, setEnablereferraldBtn] = useState(true);
  const [enableseasonalBtn, setEnableseasonalBtn] = useState(true);
  // New state variables for banner customization
  const [seasonalBannerText, setSeasonalBannerText] = useState("");
  const [seasonalBannerFontSize, setSeasonalBannerFontSize] = useState("");
  const [seasonalBannerFontColor, setSeasonalBannerFontColor] = useState("");
  const [seasonalBannerBgColor, setSeasonalBannerBgColor] = useState("");

  // Toggle edit mode functions for each section
  const toggleEditThreshold = () => setEditThreshold(!isEditThreshold);
  const toggleEditFirstOrder = () => setEditFirstOrder(!isEditFirstOrder);
  const toggleEditSignupOrder = () => setEditSignupOrder(!isEditSignupOrder);
  const toggleEditReferral = () => setEditReferral(!isEditReferral);
  const toggleEditSeasonal = () => setEditSeasonal(!isEditSeasonal);
  const [referralType, setReferralType] = useState("signup");
  const [enableThreshold, setEnableThreshold] = useState(true);
  const [warnings, setWarnings] = useState({
    disabled: false,
    message: "",
    tone: "warning",
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const paramValue = urlParams.get("shop") || shopUrl;
    const GET_SHOP_RULES = `${process.env.REACT_APP_API_URL}/api/shopify/shop/rules?shop=${paramValue}`;
    const GET_SHOP_PLAN = `${process.env.REACT_APP_API_URL}/api/shopify/plan?shop=${paramValue}`;
    axios
      .get(GET_SHOP_PLAN)
      .then((result) => {
        let response = result.data;
        console.log("Result", result);
        if (response.data && response.data.status != "ACTIVE") {
          console.log("i m in");
          navigate(`/plan`);
          setTimeout(() => {
            setLoader(false);
          }, 1000);
        } else {
          axios
            .get(GET_SHOP_RULES)
            .then((res) => {
              let response = res.data;
              // Update state based on data from the API
              if (response) {
                if (
                  response.storeDetails &&
                  response.storeDetails.data &&
                  response.storeDetails.data.shop &&
                  response.storeDetails.data.shop.shopOwnerName
                ) {
                  setShopOwner(response.storeDetails.data.shop.shopOwnerName);
                }
                let rules_slug_arr = response.data.map(
                  (rule) => rule.rule_slug
                );
                console.log("rules_slug", rules_slug_arr);
                if (!rules_slug_arr.includes("first-order-reward")) {
                  setOpenFirstOrder(true);
                  setFirstOrderCaret(true);
                }
                if (!rules_slug_arr.includes("signup-store-credit")) {
                  setOpenSignupOrder(true);
                  setSignupOrderCaret(true);
                }
                if (!rules_slug_arr.includes("order-amount-threshold")) {
                  setOpenThreshold(true);
                  setThresholdCaret(true);
                }
                if (!rules_slug_arr.includes("referral-reward")) {
                  setOpenReferral(true);
                  setReferralCaret(true);
                }
                if (!rules_slug_arr.includes("seasonal-promotions")) {
                  setOpenSeasonal(true);
                  setSeasonalCaret(true);
                }
                response.data.forEach((rule) => {
                  switch (rule.rule_slug) {
                    case "first-order-reward":
                      setFirstOrderCredit(rule.credit);
                      setFirstOrderCreditExpiry(rule.expiry);
                      setFirstOrderCreditExpiryEnable(rule.expiry_enable);
                      setEnableFirstOrderBtn(rule.enable);
                      setEditFirstOrder(rule.enable);
                      setOpenFirstOrder(rule.enable);
                      setFirstOrderCaret(rule.enable);
                      break;
                    case "signup-store-credit":
                      setSignupStoreCredit(rule.credit);
                      setSignupStoreCreditExpiry(rule.expiry);
                      setSignupStoreCreditExpiryEnable(rule.expiry_enable);
                      setEnablesignupStoredBtn(rule.enable);
                      setEditSignupOrder(rule.enable);
                      setOpenSignupOrder(rule.enable);
                      setSignupOrderCaret(rule.enable);
                      break;
                    case "order-amount-threshold":
                      setOrderThreshold({
                        greaterThan: rule.condition.match(/\d+/)[0] || "",
                        greaterThanVal: rule.credit || "",
                      });
                      setOrderThresholdExpiry(rule.expiry);
                      setOrderThresholdExpiryEnable(rule.expiry_enable);
                      setEnableThresholdBtn(rule.enable);
                      setEditThreshold(rule.enable);
                      setOpenThreshold(rule.enable);
                      setThresholdCaret(rule.enable);
                      break;
                    case "referral-reward":
                      if (rule.condition === "Referral on Signup") {
                        setReferralType("signup");
                        setReferralOnSignup(rule.credit);
                        setReferralOnOrder("");
                        setEnablereferraldBtn(rule.enable);
                        setEditReferral(rule.enable);
                        setOpenReferral(rule.enable);
                        setReferralCaret(rule.enable);
                        setReferralExpiry(rule.expiry);
                        setReferralExpiryEnable(rule.expiry_enable);
                      } else if (rule.condition === "Referral on Order") {
                        setReferralType("order");
                        setReferralOnOrder(rule.credit);
                        setReferralOnSignup("");
                        setEnablereferraldBtn(rule.enable);
                        setEditReferral(rule.enable);
                        setOpenReferral(rule.enable);
                        setReferralCaret(rule.enable);
                        setReferralExpiry(rule.expiry);
                        setReferralExpiryEnable(rule.expiry_enable);
                      }
                      break;
                    case "seasonal-promotions":
                      console.log("==== Rule =====", rule);
                      setSeasonalPromotion({
                        date:
                          rule.condition.match(/\d{4}-\d{2}-\d{2}/)[0] || "",
                        credit: rule.credit || "",
                      });
                      setEnableseasonalBtn(rule.enable);
                      setEditSeasonal(rule.enable);
                      setOpenSeasonal(rule.enable);
                      setSeasonalCaret(rule.enable);
                      setSeasonalPromotionExpiry(rule.expiry);
                      setSeasonalPromotionExpiryEnable(rule.expiry_enable);

                      if (rule.other_settings) {
                        let otherSettings = JSON.parse(rule.other_settings);
                        setSeasonalBannerText(otherSettings.banner_text || "");
                        setSeasonalBannerFontSize(
                          otherSettings.font_size
                            ? otherSettings.font_size.toString()
                            : "16"
                        );
                        setSeasonalBannerFontColor(
                          otherSettings.font_color || "#000000"
                        );
                        setSeasonalBannerBgColor(
                          otherSettings.bg_color || "#FFFFFF"
                        );
                      }
                      break;
                    default:
                      break;
                  }
                });
                setTimeout(() => {
                  setLoader(false);
                }, 1000);
              }
            })
            .catch((error) => {
              console.log("Error fetching rewards data:", error);
              setWarnings({
                disabled: true,
                message: error.message,
                tone: "warning",
              });
              handleClick();
              setTimeout(() => {
                setLoader(false);
              }, 1000);
            });
        }
      })
      .catch((error) => {
        // navigate(`/plan?shop=${paramValue}`);
        setTimeout(() => {
          setLoader(false);
        }, 1000);
        console.log(error);
      });
  }, []);

  // Handle radio button selection for referral type
  const handleReferralTypeChange = (type) => {
    setReferralType(type);
    if (type === "signup") {
      setReferralOnOrder(""); // Clear other field
    } else {
      setReferralOnSignup("");
    }
  };

  // Function to handle form submission
  const handleSave = () => {
    const formData = {
      firstOrderCredit: firstOrderCredit !== "" ? firstOrderCredit : 0,
      firstOrderCreditExpiry:
        firstOrderCreditExpiry != "" ? firstOrderCreditExpiry : 0,
      firstOrderCreditExpiryEnable,
      firstOrderEnable: enableFirstOrderBtn,
      orderThreshold: [
        {
          greaterThan: parseFloat(
            orderThreshold.greaterThan !== "" ? orderThreshold.greaterThan : 0
          ),
          greaterThanVal: parseFloat(
            orderThreshold.greaterThanVal !== ""
              ? orderThreshold.greaterThanVal
              : 0
          ),
        },
      ],
      orderThresholdExpiry:
        orderThresholdExpiry != "" ? orderThresholdExpiry : 0,
      orderThresholdExpiryEnable,
      orderThresholdEnable: enableThresholdBtn,
      referralOnOrder: parseFloat(referralOnOrder !== "" ? referralOnOrder : 0),
      referralExpiry: referralExpiry != "" ? referralExpiry : 0,
      referralExpiryEnable,
      referralOnSignup: parseFloat(
        referralOnSignup !== "" ? referralOnSignup : 0
      ),
      referralEnable: enablereferraldBtn,
      signupStoreCredit: parseFloat(
        signupStoreCredit !== "" ? signupStoreCredit : 0
      ),
      signupStoreCreditExpiry:
        signupStoreCreditExpiry != "" ? signupStoreCreditExpiry : 0,
      signupStoreCreditExpiryEnable,
      signupStoreCreditEnable: enablesignupStoredBtn,

      seasonalPromotion: {
        date: seasonalPromotion.date,
        credit: parseFloat(
          seasonalPromotion.credit !== "" ? seasonalPromotion.credit : 0
        ),
      },
      seasonalPromotionExpiry:
        seasonalPromotionExpiry != "" ? seasonalPromotionExpiry : 0,
      seasonalPromotionExpiryEnable,
      seasonalEnable: enableseasonalBtn,

      // New fields for Promotional Banner
      seasonalBannerText: seasonalBannerText.trim(), // Text for the banner
      seasonalBannerFontSize:
        seasonalBannerFontSize !== ""
          ? parseInt(seasonalBannerFontSize, 10)
          : 16, // Default 16px
      seasonalBannerFontColor:
        seasonalBannerFontColor !== "" ? seasonalBannerFontColor : "#000000", // Default Black
      seasonalBannerBgColor:
        seasonalBannerBgColor !== "" ? seasonalBannerBgColor : "#FFFFFF", // Default White
    };

    console.log("Form Data:", formData);

    // Validate new fields
    if (
      (enableseasonalBtn && seasonalBannerFontSize < 10) ||
      seasonalBannerFontSize > 50
    ) {
      setWarnings({
        disabled: true,
        message: "Font size should be between 10px and 50px!",
        tone: "warning",
      });
      handleClick();
      return;
    }

    if (enableseasonalBtn && !/^#[0-9A-F]{6}$/i.test(seasonalBannerFontColor)) {
      setWarnings({
        disabled: true,
        message: "Invalid font color format! Use hex code (e.g., #FF0000).",
        tone: "warning",
      });
      handleClick();
      return;
    }

    if (enableseasonalBtn && !/^#[0-9A-F]{6}$/i.test(seasonalBannerBgColor)) {
      setWarnings({
        disabled: true,
        message:
          "Invalid background color format! Use hex code (e.g., #FFFFFF).",
        tone: "warning",
      });
      handleClick();
      return;
    }

    // Fetch shop parameter and make POST request
    const urlParams = new URLSearchParams(location.search);
    const paramValue = urlParams.get("shop");

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/shopify/shop/rules?shop=${paramValue}`,
        formData
      )
      .then((data) => {
        console.log("Data saved successfully:", data);
        setWarnings({
          disabled: true,
          message: "Rewards data saved successfully!",
          tone: "success",
        });
        handleClick();
      })
      .catch((error) => {
        console.error("Error:", error);
        setWarnings({
          disabled: true,
          message: "Failed to save rewards data.",
          tone: "warning",
        });
        handleClick();
      });
  };

  const handleCaret = (type, val = null) => {
    switch (type) {
      case "Threshold":
        setThresholdCaret(val ? val : !thresholdCaret);
        break;
      case "FirstOrder":
        setFirstOrderCaret(val ? val : !firstOrderCaret);
        break;
      case "SignupOrder":
        setSignupOrderCaret(val ? val : !signupOrderCaret);
        break;
      case "Referral":
        setReferralCaret(val ? val : !referralCaret);
        break;
      case "Seasonal":
        setSeasonalCaret(val ? val : !seasonalCaret);
        break;
      default:
        break;
    }
    return;
  };

  const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };
  if (loader) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          position: "relative",
          top: "150px",
        }}
      >
        <Spinner accessibilityLabel="Spinner example" size="large" />
      </div>
    );
  }
  return (
    <Page fullWidth>
      {warnings.disabled && (
        <div ref={ref}>
          <Banner
            title={warnings.message}
            tone={warnings.tone}
            onDismiss={() =>
              setWarnings({ disabled: false, message: "", tone: "info" })
            }
          ></Banner>
        </div>
      )}
      <Card roundedAbove="lg">
        <div className="title-bar--style">
          <InlineGrid
            alignItems="start"
            columns="1fr auto 1fr 1fr  1fr 1fr 1fr 1fr 1fr 3fr 1fr"
          >
            <div
              style={{
                position: "relative",
                display: "flex",
                top: "-2px",
                justifyContent: "end",
              }}
            >
              <AppIcon />
            </div>
            <div style={{ position: "relative" }}>
              <Text as="h2" variant="headingLg">
                CredUP Reward Options
              </Text>
            </div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div style={{ fontWeight: "700" }}>
              {shopOwner && `Hey there ${shopOwner} 👋`}
            </div>
            <div></div>
          </InlineGrid>
        </div>
        {/* Order Amount Threshold */}
        <div className="marginTop"></div>
        <InlineGrid columns="12fr 1fr">
          <div
            onClick={() => {
              // toggleEditThreshold();
              setOpenThreshold(!openThreshold);
              handleCaret("Threshold");
            }}
            className="pointer"
          >
            <InlineGrid alignItems="start" columns="1fr 3fr 6fr 1.7fr">
              <div style={{ position: "relative", left: "27px" }}>
                <SortAmount />
              </div>
              <Text as="h2" variant="headingSm">
                Order Amount Threshold
              </Text>
              <div></div>
              <Icon source={!thresholdCaret ? CaretDownIcon : CaretUpIcon} />
            </InlineGrid>
          </div>
          <div>
            {loader ? (
              <Spinner
                accessibilityLabel="Small spinner example"
                size="small"
              />
            ) : enableThresholdBtn ? (
              <Button
                tone="critical"
                variant="primary"
                onClick={() => {
                  setEditThreshold(false);
                  setEnableThresholdBtn(false);
                  setOpenThreshold(false);
                  handleCaret("Threshold", false);
                }}
              >
                Disable
              </Button>
            ) : (
              <Button
                tone="success"
                variant="primary"
                onClick={() => {
                  setOpenThreshold(true);
                  setEditThreshold(true);
                  setEnableThresholdBtn(true);
                  handleCaret("Threshold", true);
                }}
              >
                Enable
              </Button>
            )}
          </div>
        </InlineGrid>
        {openThreshold && (
          <InlineGrid
            alignItems="start"
            columns="1fr 2.5fr 1fr 1.5fr 1fr 1.5fr 1.5fr 1fr 1fr"
          >
            <div></div>
            <div style={{ marginTop: "5px" }}>
              <Text as="h2" variant="bodyLg" fontWeight="800">
                If your order amount exceeds
              </Text>
            </div>
            <TextField
              value={orderThreshold.greaterThan}
              onChange={(value) => {
                const validatedValue = value < 1 ? 1 : value; // Ensures minimum is 1
                setOrderThreshold((prev) => ({
                  ...prev,
                  greaterThan: validatedValue,
                }));
              }}
              type="number"
              disabled={!isEditThreshold}
            />
            <div style={{ marginTop: "5px", marginLeft: "15px" }}>
              <Text as="h2" variant="bodyLg" fontWeight="500">
                you will receive
              </Text>
            </div>
            <TextField
              value={orderThreshold.greaterThanVal}
              onChange={(value) => {
                const validatedValue = value < 1 ? 1 : value; // Ensures minimum is 1
                setOrderThreshold((prev) => ({
                  ...prev,
                  greaterThanVal: validatedValue,
                }));
              }}
              type="number"
              disabled={!isEditThreshold}
            />
            <div style={{ marginTop: "5px", marginLeft: "15px" }}>
              <Text as="h1" variant="bodyLg" fontWeight="800">
                Credits
              </Text>
            </div>
            <div style={{ position: "relative", right: "40px" }}>
              <Checkbox
                label="Set Expiry"
                checked={orderThresholdExpiryEnable}
                onChange={() =>
                  setOrderThresholdExpiryEnable(!orderThresholdExpiryEnable)
                }
                disabled={!isEditThreshold}
              />
            </div>
            <div style={{ position: "relative", right: "65px" }}>
              <TextField
                value={orderThresholdExpiry}
                onChange={(value) => {
                  const validatedValue = value < 1 ? 1 : value;
                  setOrderThresholdExpiry(validatedValue);
                }}
                type="number"
                disabled={
                  isEditThreshold && orderThresholdExpiryEnable ? false : true
                }
              />
            </div>
            <div
              style={{ marginTop: "6px", position: "relative", right: "45px" }}
            >
              <Text as="h1" variant="bodyLg" fontWeight="800">
                Expiry Days
              </Text>
            </div>
            {/* <div onClick={toggleEditThreshold} style={{marginTop:"5px"}}>
            <Icon source={EditIcon} className='pointer' />
            </div> */}
          </InlineGrid>
        )}

        {/* First Order */}
        <div className="marginTop"></div>
        <InlineGrid alignItems="start" columns="12fr 1fr">
          <div
            className="pointer"
            onClick={() => {
              // toggleEditFirstOrder();
              setOpenFirstOrder(!openFirstOrder);
              handleCaret("FirstOrder");
            }}
          >
            <InlineGrid alignItems="start" columns="1fr 3fr 6fr 1.7fr">
              <div style={{ position: "relative", left: "27px" }}>
                <Checkout />
              </div>
              <Text as="h2" variant="headingSm">
                First Order
              </Text>
              <div></div>
              <div
                className="pointer"
                onClick={() => {
                  setOpenFirstOrder(!openFirstOrder);
                  handleCaret("FirstOrder");
                }}
              >
                <Icon source={!firstOrderCaret ? CaretDownIcon : CaretUpIcon} />
              </div>
            </InlineGrid>
          </div>
          {/* <Button tone='success' variant='primary'>Enabled</Button> */}
          {/* <Button tone='critical' variant='primary'>Disabled</Button> */}
          <div>
            {loader ? (
              <Spinner
                accessibilityLabel="Small spinner example"
                size="small"
              />
            ) : enableFirstOrderBtn ? (
              <Button
                tone="critical"
                variant="primary"
                onClick={() => {
                  // setOpenFirstOrder(false);
                  setEnableFirstOrderBtn(false);
                  setEditFirstOrder(false);
                  setOpenFirstOrder(false);
                  handleCaret("FirstOrder", false);
                }}
              >
                Disable
              </Button>
            ) : (
              <Button
                tone="success"
                variant="primary"
                onClick={() => {
                  setOpenFirstOrder(true);
                  setEditFirstOrder(true);
                  setEnableFirstOrderBtn(true);
                  handleCaret("FirstOrder", true);
                }}
              >
                Enable
              </Button>
            )}
          </div>
        </InlineGrid>
        {openFirstOrder && (
          <InlineGrid
            alignItems="start"
            columns="1fr 2.5fr 1fr 1.5fr 1.5fr 1fr 2fr 1.5fr"
          >
            <div></div>
            <div style={{ marginTop: "5px" }}>
              <Text as="h2" variant="bodyLg" fontWeight="800">
                Number of store credit on First Order
              </Text>
            </div>
            <TextField
              value={firstOrderCredit}
              onChange={(value) => {
                const validatedValue = value < 1 ? 1 : value; // Ensures minimum is 1
                setFirstOrderCredit(validatedValue);
              }}
              type="number"
              disabled={!isEditFirstOrder}
            />
            <div style={{ marginTop: "5px", marginLeft: "15px" }}>
              <Text as="h1" variant="bodyLg" fontWeight="800">
                Credits
              </Text>
            </div>
            <div style={{ position: "relative", right: "20px" }}>
              <Checkbox
                label="Set Expiry"
                checked={firstOrderCreditExpiryEnable}
                onChange={() =>
                  setFirstOrderCreditExpiryEnable(!firstOrderCreditExpiryEnable)
                }
                disabled={!isEditFirstOrder}
              />
            </div>
            <div style={{ position: "relative", right: "25px" }}>
              <TextField
                value={firstOrderCreditExpiry}
                onChange={(value) => {
                  const validatedValue = value < 1 ? 1 : value; // Ensures minimum is 1
                  setFirstOrderCreditExpiry(validatedValue);
                }}
                type="number"
                disabled={
                  isEditFirstOrder && firstOrderCreditExpiryEnable
                    ? false
                    : true
                }
              />
            </div>
            <div style={{ marginTop: "6px", position: "relative" }}>
              <Text as="h1" variant="bodyLg" fontWeight="800">
                Expiry Days
              </Text>
            </div>
            <div></div>
            {/* <div onClick={toggleEditFirstOrder} style={{marginTop:"5px"}}>
            <Icon source={EditIcon} className='pointer' />
            </div> */}
          </InlineGrid>
        )}

        {/* Signup Order */}
        <div className="marginTop"></div>
        <InlineGrid columns="12fr 1fr">
          <div
            className="pointer"
            onClick={() => {
              // toggleEditSignupOrder();
              setOpenSignupOrder(!openSignupOrder);
              handleCaret("SignupOrder");
            }}
          >
            <InlineGrid alignItems="start" columns="1fr 3fr 6fr 1.7fr">
              <div style={{ position: "relative", left: "27px" }}>
                <AddFriend />
              </div>
              <Text as="h2" variant="headingSm">
                On SignUp
              </Text>
              <div></div>
              <div className="pointer">
                <Icon
                  source={!signupOrderCaret ? CaretDownIcon : CaretUpIcon}
                />
              </div>
            </InlineGrid>
          </div>
          {/* <Button tone='success' variant='primary'>Enabled</Button> */}
          {/* <Button tone='critical' variant='primary'>Disabled</Button> */}
          <div>
            {loader ? (
              <Spinner
                accessibilityLabel="Small spinner example"
                size="small"
              />
            ) : enablesignupStoredBtn ? (
              <Button
                tone="critical"
                variant="primary"
                onClick={() => {
                  // setOpenFirstOrder(false);
                  setEnablesignupStoredBtn(false);
                  setEditSignupOrder(false);
                  setOpenSignupOrder(false);
                  handleCaret("SignupOrder", false);
                }}
              >
                Disable
              </Button>
            ) : (
              <Button
                tone="success"
                variant="primary"
                onClick={() => {
                  setOpenSignupOrder(true);
                  setEditSignupOrder(true);
                  setEnablesignupStoredBtn(true);
                  handleCaret("SignupOrder", true);
                }}
              >
                Enable
              </Button>
            )}
          </div>
        </InlineGrid>
        {openSignupOrder && (
          <InlineGrid
            alignItems="start"
            columns="1fr 2.5fr 1fr 1.5fr 1.5fr 1fr 2fr 1.5fr"
          >
            <div></div>
            <Text as="h2" variant="bodyLg" fontWeight="800">
              Number of store credit on Signup
            </Text>
            <TextField
              value={signupStoreCredit}
              onChange={(value) => {
                const validatedValue = value < 1 ? 1 : value; // Ensures minimum is 1
                setSignupStoreCredit(validatedValue);
              }}
              type="number"
              disabled={!isEditSignupOrder}
            />
            <div style={{ marginTop: "5px", marginLeft: "15px" }}>
              <Text as="h1" variant="bodyLg" fontWeight="800">
                Credits
              </Text>
            </div>
            <div style={{ position: "relative", right: "20px" }}>
              <Checkbox
                label="Set Expiry"
                checked={signupStoreCreditExpiryEnable}
                onChange={() =>
                  setSignupStoreCreditExpiryEnable(
                    !signupStoreCreditExpiryEnable
                  )
                }
                disabled={!isEditSignupOrder}
              />
            </div>
            <div style={{ position: "relative", right: "20px" }}>
              <TextField
                value={signupStoreCreditExpiry}
                onChange={(value) => {
                  const validatedValue = value < 1 ? 1 : value; // Ensures minimum is 1
                  setSignupStoreCreditExpiry(validatedValue);
                }}
                type="number"
                disabled={
                  isEditSignupOrder && signupStoreCreditExpiryEnable
                    ? false
                    : true
                }
              />
            </div>
            <div style={{ marginTop: "6px", position: "relative" }}>
              <Text as="h1" variant="bodyLg" fontWeight="800">
                Expiry Days
              </Text>
            </div>
            {/* <div onClick={toggleEditSignupOrder} style={{marginTop:"5px"}}>
            <Icon source={EditIcon} className='pointer' />
            </div> */}
          </InlineGrid>
        )}

        {/* Referral Reward */}
        <div className="marginTop"></div>
        <InlineGrid columns="12fr 1fr">
          <div
            className="pointer"
            onClick={() => {
              // toggleEditReferral();
              setOpenReferral(!openReferral);
              handleCaret("Referral");
            }}
          >
            <InlineGrid alignItems="start" columns="1fr 3fr 6fr 1.7fr">
              <div style={{ position: "relative", left: "25px", top: "-3px" }}>
                <Collaboration />
              </div>
              <Text as="h2" variant="headingSm">
                Referral Reward
              </Text>
              <div></div>
              <div className="pointer">
                <Icon source={!referralCaret ? CaretDownIcon : CaretUpIcon} />
              </div>
            </InlineGrid>
          </div>
          {/* <Button tone='success' variant='primary'>Enabled</Button> */}
          {/* <Button tone='critical' variant='primary'>Disabled</Button> */}
          <div>
            {loader ? (
              <Spinner
                accessibilityLabel="Small spinner example"
                size="small"
              />
            ) : enablereferraldBtn ? (
              <Button
                tone="critical"
                variant="primary"
                onClick={() => {
                  // setOpenFirstOrder(false);
                  setEnablereferraldBtn(false);
                  setEditReferral(false);
                  setOpenReferral(false);
                  handleCaret("Referral", false);
                }}
              >
                Disable
              </Button>
            ) : (
              <Button
                tone="success"
                variant="primary"
                onClick={() => {
                  setOpenReferral(true);
                  setEditReferral(true);
                  setEnablereferraldBtn(true);
                  handleCaret("Referral", true);
                }}
              >
                Enable
              </Button>
            )}
          </div>
        </InlineGrid>
        {openReferral && (
          <InlineGrid
            alignItems="start"
            columns="1fr 2.5fr 1fr 1.5fr 1fr 1.5fr 1.5fr 1fr 1fr"
          >
            <div></div>
            <RadioButton
              label="Based On Signup"
              checked={referralType === "signup"}
              onChange={() => handleReferralTypeChange("signup")}
              disabled={!isEditReferral}
            />
            <TextField
              value={referralOnSignup}
              onChange={(value) => {
                const validatedValue = value < 1 ? 1 : value; // Ensures minimum is 1
                setReferralOnSignup(validatedValue);
              }}
              type="number"
              disabled={!isEditReferral}
            />
            <div>
              <RadioButton
                label="Based On First Order"
                checked={referralType === "order"}
                onChange={() => handleReferralTypeChange("order")}
                disabled={!isEditReferral}
              />
            </div>
            <TextField
              value={referralOnOrder}
              onChange={(value) => {
                const validatedValue = value < 1 ? 1 : value; // Ensures minimum is 1
                setReferralOnOrder(validatedValue);
              }}
              type="number"
              disabled={!isEditReferral}
            />
            <div style={{ marginTop: "5px", marginLeft: "15px" }}>
              <Text as="h1" variant="bodyLg" fontWeight="800">
                Credits
              </Text>
            </div>
            <div style={{ position: "relative", right: "40px" }}>
              <Checkbox
                label="Set Expiry"
                checked={referralExpiryEnable}
                onChange={() => setReferralExpiryEnable(!referralExpiryEnable)}
                disabled={!isEditReferral}
              />
            </div>
            <div style={{ position: "relative", right: "65px" }}>
              <TextField
                value={referralExpiry}
                onChange={(value) => {
                  const validatedValue = value < 1 ? 1 : value; // Ensures minimum is 1
                  setReferralExpiry(validatedValue);
                }}
                type="number"
                disabled={isEditReferral && referralExpiryEnable ? false : true}
              />
            </div>
            <div
              style={{ marginTop: "6px", position: "relative", right: "45px" }}
            >
              <Text as="h1" variant="bodyLg" fontWeight="800">
                Expiry Days
              </Text>
            </div>
            {/* <div onClick={toggleEditReferral} style={{marginTop:"5px"}}>
            <Icon source={EditIcon} className='pointer' />
            </div> */}
          </InlineGrid>
        )}

        {/* Seasonal Promotions */}
        <div className="marginTop"></div>
        <InlineGrid columns="12fr 1fr">
          <div
            className="pointer"
            onClick={() => {
              // toggleEditSeasonal();
              setOpenSeasonal(!openSeasonal);
              handleCaret("Seasonal");
            }}
          >
            <InlineGrid alignItems="start" columns="1fr 3fr 6fr 1.7fr">
              <div style={{ position: "relative", left: "23px", top: "-4px" }}>
                <Promotion />
              </div>
              <Text as="h2" variant="headingSm">
                Seasonal Promotions
              </Text>
              <div></div>
              <div className="pointer">
                <Icon source={!seasonalCaret ? CaretDownIcon : CaretUpIcon} />
              </div>
            </InlineGrid>
          </div>
          {/* <Button tone='success' variant='primary'>Enabled</Button> */}
          {/* <Button tone='critical' variant='primary'>Disabled</Button> */}
          <div>
            {loader ? (
              <Spinner
                accessibilityLabel="Small spinner example"
                size="small"
              />
            ) : enableseasonalBtn ? (
              <Button
                tone="critical"
                variant="primary"
                onClick={() => {
                  // setOpenFirstOrder(false);
                  setEnableseasonalBtn(false);
                  setEditSeasonal(false);
                  setOpenSeasonal(false);
                  handleCaret("Seasonal", false);
                }}
              >
                Disable
              </Button>
            ) : (
              <Button
                tone="success"
                variant="primary"
                onClick={() => {
                  setOpenSeasonal(true);
                  setEditSeasonal(true);
                  setEnableseasonalBtn(true);
                  handleCaret("Seasonal", true);
                }}
              >
                Enable
              </Button>
            )}
          </div>
        </InlineGrid>
        {openSeasonal && (
          <InlineGrid
            alignItems="start"
            columns="1fr 2.5fr auto 1.5fr 1fr 1.5fr 1.5fr 1fr 1fr"
          >
            <div></div>
            <div style={{ position: "relative", left: "5px" }}>
              <Text as="h2" variant="bodyLg" fontWeight="800">
                Place Order before
              </Text>
            </div>
            <div style={{ position: "relative" }}>
              <TextField
                value={seasonalPromotion.date}
                onChange={(value) =>
                  setSeasonalPromotion((prev) => ({ ...prev, date: value }))
                }
                type="date"
                disabled={!isEditSeasonal}
                min={getTodayDate()}
              />
            </div>
            <div style={{ marginTop: "5px", marginLeft: "15px" }}>
              <Text as="h2" variant="bodyLg" fontWeight="800">
                Receive
              </Text>
            </div>
            <div style={{ position: "relative", right: "16px" }}>
              <TextField
                value={seasonalPromotion.credit}
                onChange={(value) => {
                  const validatedValue = value < 1 ? 1 : value; // Ensures minimum is 1
                  setSeasonalPromotion((prev) => ({
                    ...prev,
                    credit: validatedValue,
                  }));
                }}
                type="number"
                disabled={!isEditSeasonal}
              />
            </div>
            <div style={{ position: "relative", top: "3px" }}>
              <Text as="h1" variant="bodyLg" fontWeight="800">
                Credits
              </Text>
            </div>
            <div style={{ position: "relative", right: "51px" }}>
              <Checkbox
                label="Set Expiry"
                checked={seasonalPromotionExpiryEnable}
                onChange={() =>
                  setSeasonalPromotionExpiryEnable(
                    !seasonalPromotionExpiryEnable
                  )
                }
                disabled={!isEditSeasonal}
              />
            </div>
            <div style={{ position: "relative", right: "65px" }}>
              <TextField
                value={seasonalPromotionExpiry}
                onChange={(value) => {
                  const validatedValue = value < 1 ? 1 : value; // Ensures minimum is 1
                  setSeasonalPromotionExpiry(validatedValue);
                }}
                type="number"
                disabled={
                  isEditSeasonal && seasonalPromotionExpiryEnable ? false : true
                }
              />
            </div>
            <div
              style={{ marginTop: "6px", position: "relative", right: "45px" }}
            >
              <Text as="h1" variant="bodyLg" fontWeight="800">
                Expiry Days
              </Text>
            </div>
            {/* <div onClick={toggleEditSeasonal} style={{position:"relative", right:"10px", top:'2px'}}>
            <Icon source={EditIcon} className='pointer' />
            </div> */}
          </InlineGrid>
        )}
        <div style={{ marginBottom: "8px" }}></div>
        {openSeasonal && (
          <InlineGrid
            alignItems="start"
            columns="1fr 2.5fr auto 1.5fr 1fr 1.5fr 1.5fr 1fr 1fr"
          >
            <div></div>
            <div style={{ position: "relative", left: "5px" }}>
              <Text as="h2" variant="bodyLg" fontWeight="800">
                Promotional Banner Text
              </Text>
            </div>
            <div style={{ position: "relative", width: "140px" }}>
              <TextField
                value={seasonalBannerText}
                onChange={setSeasonalBannerText}
                type="text"
                disabled={!isEditSeasonal}
                placeholder="Promotion Text"
              />
            </div>
            <div style={{ marginTop: "5px", marginLeft: "15px" }}>
              <Text as="h2" variant="bodyLg" fontWeight="800">
                Size(px)
              </Text>
            </div>
            <div style={{ position: "relative", right: "16px" }}>
              <TextField
                value={seasonalBannerFontSize}
                onChange={setSeasonalBannerFontSize}
                type="number"
                disabled={!isEditSeasonal}
                placeholder="Font size"
              />
            </div>
            <div style={{ position: "relative", top: "3px" }}>
              <Text as="h2" variant="bodyLg" fontWeight="800">
                Color
              </Text>
            </div>
            <div style={{ position: "relative", right: "51px", width: "60px" }}>
              <TextField
                value={seasonalBannerFontColor}
                onChange={setSeasonalBannerFontColor}
                type="color"
                disabled={!isEditSeasonal}
              />
            </div>
            <div
              style={{
                position: "relative",
                right: "65px",
                top: "5px",
                width: "114px",
              }}
            >
              <Text as="h2" variant="bodyLg" fontWeight="800">
                Background Color
              </Text>
            </div>
            <div
              style={{
                marginTop: "6px",
                position: "relative",
                right: "45px",
                width: "60px",
              }}
            >
              <TextField
                value={seasonalBannerBgColor}
                onChange={setSeasonalBannerBgColor}
                type="color"
                disabled={!isEditSeasonal}
              />
            </div>
          </InlineGrid>
        )}

        <div className="marginTop"></div>
        <Divider borderColor="border" />
        <InlineGrid alignItems="start" columns="11.17fr 0.93fr">
          <div></div>
          <div style={{ width: "4rem", marginTop: "5px" }}>
            <Button fullWidth variant="primary" onClick={handleSave}>
              Save
            </Button>
          </div>
        </InlineGrid>
      </Card>
    </Page>
  );
};

export default Settings;
